import { useEditorStore } from '../store/editor-store';

const OPTIONS: Array<{
  value: 'no_white_base' | 'white_base';
  label: string;
  hint: string;
}> = [
  { value: 'no_white_base', label: 'Sin base blanca', hint: 'Prendas muy claras' },
  { value: 'white_base', label: 'Con base blanca', hint: 'Oscuras o que necesiten blanco' },
];

/** Garment print type + franela controls for print-service models. */
export function PrintServiceOptions() {
  const model = useEditorStore((s) => s.model);
  const garmentPrintType = useEditorStore((s) => s.document.selection.garmentPrintType);
  const franelaReactiva = useEditorStore((s) => s.document.selection.franelaReactiva);
  const setGarmentPrintType = useEditorStore((s) => s.setGarmentPrintType);
  const setFranelaReactiva = useEditorStore((s) => s.setFranelaReactiva);

  if (!model?.printService) return null;

  const surcharge = model.franelaSurcharge ?? 0;
  const currency = model.priceFrom?.currency ?? 'PEN';

  return (
    <div className="ox-print-service-opts">
      <p className="ox-print-service-opts__title">Tipo de impresión</p>
      <div className="ox-print-service-opts__choices">
        {OPTIONS.map((opt) => {
          const on = garmentPrintType === opt.value;
          return (
            <label
              key={opt.value}
              className={`ox-print-service-opts__opt${on ? ' is-on' : ''}`}
              // Inline so storefront themes cannot override the selected state.
              style={
                on
                  ? {
                      borderColor: 'var(--ox-red, #e11d48)',
                      boxShadow: 'inset 0 0 0 1px var(--ox-red, #e11d48)',
                      background: '#fff5f5',
                    }
                  : undefined
              }
            >
              <input
                type="radio"
                name="ox-garment-print-type"
                checked={on}
                onChange={() => setGarmentPrintType(opt.value)}
              />
              <span>
                {opt.label}
                <small>{opt.hint}</small>
              </span>
              <span className="ox-print-service-opts__check" aria-hidden>
                {on ? '✓' : ''}
              </span>
            </label>
          );
        })}
      </div>
      {!garmentPrintType ? (
        <p className="ox-print-service-opts__hint">Elige el tipo de prenda para calcular el precio.</p>
      ) : null}
      {surcharge > 0 ? (
        <label className="ox-print-service-opts__franela">
          <input
            type="checkbox"
            checked={!!franelaReactiva}
            onChange={(e) => setFranelaReactiva(e.target.checked)}
          />
          Es franela reactiva (+{currency} {surcharge.toFixed(2)})
        </label>
      ) : null}
    </div>
  );
}
